export default {
    min_entries: 2,
    attributes: [
        { attribute: 'category_ids', type: 'tree', name: 'facet.category' },
        { attribute: 'final_price', type: 'slider', name: 'facet.price', unit: '€' },
        {
            as: 'size',
            attribute: ['kw_sizeindex', 'kw_sizeindex_shoes'],
            type: 'list',
            search_children: true,
            name: 'facet.size',
        },

        { attribute: 'kw_material_type', type: 'list', search_children: true, name: 'facet.material_type' },
        { attribute: 'kw_product_type', type: 'list', search_children: true, name: 'facet.product_type' },
        { attribute: 'kw_main_color', type: 'list', search_children: true, name: 'facet.color' },
        { attribute: 'pim_brand', type: 'list', search_children: true, name: 'facet.brand' },
        { attribute: 'kw_serie', type: 'list', search_children: true, name: 'facet.series' },
        { attribute: 'kw_material_new', type: 'list', search_children: true, name: 'facet.material' },
        {
            as: 'exterior',
            attribute: ['kw_outdoor_diverse', 'kw_outdoor_luggages', 'kw_outdoor_bags', 'kw_outdoor_backpacks'],
            type: 'list',
            search_children: true,
            name: 'facet.exterior',
        },
        {
            as: 'interior',
            attribute: ['kw_interior_diverses', 'kw_interior_luggages', 'kw_interior_bags', 'kw_interior_backpacks'],
            type: 'list',
            search_children: true,
            name: 'facet.interior',
        },
        { attribute: 'kw_rolls_num', type: 'list', search_children: true, name: 'facet.rolls_num' },
    ],
};
